import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import type { UseFormResetField, UseFormSetValue } from 'react-hook-form';
import type z from 'zod';
import type { RsFormSchema } from '../_model/project-form';

type FormValues = z.infer<typeof RsFormSchema>;
type InitialFormValues = {
  data: Partial<FormValues['data']>;
};

export const handleProjectCategoryChange = (
  value: FormValues['data']['category'],
  fiscalYear: Dayjs | null | undefined,
  setValue: UseFormSetValue<InitialFormValues>,
  resetField: UseFormResetField<InitialFormValues>,
): void => {
  setValue('data.category', value, { shouldDirty: true });

  if (fiscalYear) {
    if (value === 'new') {
      setValue('data.period', [dayjs().year(fiscalYear.year()), undefined], {
        shouldDirty: true,
      });
      resetField('data.isUnknownStart', {
        defaultValue: false,
      });
    } else if (value === 'requesting') {
      setValue(
        'data.period',
        [dayjs().year(fiscalYear.year() + 1), undefined],
        { shouldDirty: true },
      );
      resetField('data.isUnknownStart', {
        defaultValue: false,
      });
    } else if (value === 'continuation') {
      setValue('data.period', [undefined, undefined], {
        shouldDirty: true,
      });
    }
  }
};
